<template>
    <div>
        <data-table
            ref="dtJubileeOrders"
            frontinusTitle="Zoznam objednávok"
            :headers="headers"
            :frontinusItemsLoader="jubileeOrdersLoader()"
            :frontinusActionColumn="{ download: true, print: true }"
            @newItem="openFormDialog()"
            @downloadItem="downloadJubileeOrder"
            @printItem="printJubileeOrder"
        >
            <template #customFilters>
              <v-select
                v-model="activeFiltersDate"
                :items="customFilters.date"
                label="Deň vysielania"
                class="pl-1"
                clearable
                single-line
                hide-details
              ></v-select>
            </template>

            <template #item="{ item }">
              <tr :class="{ 'font-weight-black': !item.processed_at }">
                <td>{{ item.created_at | dateTime }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.age }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.time ? item.time : 'Nie' }}</td>
                <td>{{ item.pickup_place ? 'Áno' : 'Nie' }}</td>
                <td>{{ item.mp3_email_receiver ? item.mp3_email_receiver : 'Nie' }}</td>
                <td>{{ Math.round(+item.price) }} €</td>
                <td>{{ columnPaid(item.payed_at) }}</td>
                <td>
                  <v-icon class="mr-2" @click.stop="printJubileeOrder(item)">mdi-printer</v-icon>
                  <v-icon class="mr-2" @click.stop="downloadJubileeOrder(item)">mdi-download</v-icon>
                </td>
              </tr>
            </template>
        </data-table>

        <form-dialog
          v-model="showFormDialog"
          maxWidth="800px"
          @save="onSubmit()"
        >
          <v-text-field
              v-model.trim="jubileeOrderModel.name"
              label="Meno jubilanta"
              :errorMessages="validationErrors.name"
          ></v-text-field>

          <v-text-field
              v-model.trim="jubileeOrderModel.age"
              label="Vek jubilanta"
              :errorMessages="validationErrors.age"
          ></v-text-field>

          <date-picker
            v-model="jubileeOrderModel.date"
            label="Dátum (iba sobota alebo nedeľa)"
            :errorMessages="validationErrors.date"
          ></date-picker>

          <v-textarea
            v-model.trim="jubileeOrderModel.congratulations_text"
            label="Text gratulácie"
            :errorMessages="validationErrors.congratulations_text"
            :auto-grow="true"
            counter
            full-width
            outlined
          ></v-textarea>

          <template v-if="jubileeOrdersConfig && jubileeOrdersConfig.price">
            <template v-for="(price, name, i) in jubileeOrdersConfig.price.songs">
              <v-text-field
                  :key="name"
                  v-model.trim="jubileeOrderModel.songs[i]"
                  :label="name"
              ></v-text-field>
            </template>
          </template>

          <div class="d-flex justify-space-between">
              <v-checkbox
                v-model="jubileeOrderModel.cd_request"
                label="Záujem o CD"
                class="ml-3"
              ></v-checkbox>

              <v-select
                v-model="jubileeOrderModel.pickup_place"
                label="Miesto vyzdvihnutia CD"
                :items="pickupPlaces"
                :errorMessages="validationErrors.pickup_place"
                :disabled="!jubileeOrderModel.cd_request"
                class="ml-3"
                single-line
              ></v-select>
          </div>

          <div class="d-flex justify-space-between">
              <v-checkbox
                v-model="jubileeOrderModel.time_specific"
                label="Vybrať čas"
              ></v-checkbox>

              <v-select
                v-model="jubileeOrderModel.time"
                label="Čas gratulácie"
                :items="jubileeOrdersConfig.allowedTimes"
                :errorMessages="validationErrors.allowedTimes"
                :disabled="!jubileeOrderModel.time_specific"
                class="ml-3"
                single-line
              ></v-select>
          </div>

          <v-text-field
              v-model.trim="jubileeOrderModel.customer_name"
              label="Gratuláciu objednal (kontaktná osoba)"
              :errorMessages="validationErrors.customer_name"
          ></v-text-field>

          <v-text-field
              v-model.trim="jubileeOrderModel.customer_tel"
              label="Telefonický kontakt na objednávateľa"
              :errorMessages="validationErrors.customer_tel"
          ></v-text-field>

          <v-text-field
              v-model.trim="jubileeOrderModel.customer_email"
              label="E-mailová adresa objednávateľa"
              :errorMessages="validationErrors.customer_email"
          ></v-text-field>

          <v-textarea
            v-model.trim="jubileeOrderModel.note"
            label="Doplňujúce údaje, odkaz pre redakciu, zberné miesto na doručenie CD,..."
            :auto-grow="true"
            :errorMessages="validationErrors.note"
            counter
            full-width
            outlined
          ></v-textarea>

          <v-radio-group v-model="jubileeOrderModel.payment_type">
            <div class="d-flex justify-space-between">
              <v-radio label="PayPal" value="paypal" class="mb-0"></v-radio>
              <v-radio label="GoPay" value="gopay" class="mb-0"></v-radio>
              <v-radio label="Prevodom" value="bankTransfer" class="mb-0"></v-radio>
            </div>
          </v-radio-group>
        </form-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import { JubileeService } from '@/services/api/jubilee.service'
import { DownloadService } from '@/services/api/download.service'
import DataTable from '@/components/FrontinusDataTable.vue'
import FormDialog from '@/components/FormDialog.vue'
import DatePicker from '@/components/FrontinusDatePicker.vue'
import { ValidationError } from '../../errors/validation.error'

export default Vue.extend({
  components: {
    DataTable,
    FormDialog,
    DatePicker
  },

  data () {
    return {
      headers: [
        { text: 'Čas objednania', value: 'created_at' },
        { text: 'Meno jubilanta', value: 'name' },
        { text: 'Vek', value: 'age' },
        { text: 'Dátum odvysielania', value: 'date' },
        { text: 'Čas odvysielania', value: 'time' },
        { text: 'CD', value: 'pickup_place' },
        { text: 'Zaslať mp3 na e-mail', value: 'mp3_email_receiver' },
        { text: 'Suma', value: 'price' },
        { text: 'Uhradené', value: 'payed_at' },
        { text: '', value: 'action', sortable: false }
      ],
      jubileeOrdersConfig: {},
      showFormDialog: false,
      jubileeOrderModel: { songs: [] },
      validationErrors: {},
      customFilters: {},
      activeFiltersDate: null
    }
  },

  computed: {
    pickupPlaces () {
      if (!this.jubileeOrdersConfig.pickupPlaces) {
        return []
      }

      const pickupPlaces = []
      Object.entries(this.jubileeOrdersConfig.pickupPlaces).map(([city, places]) => {
        places.map(place => {
          pickupPlaces.push(`${city} - ${place}`)
        })
      })

      return pickupPlaces
    }
  },

  watch: {
    activeFiltersDate (newValue, oldValue) {
      if (oldValue !== newValue) {
        this.$nextTick(() => {
          this.$refs.dtJubileeOrders.reload()
        })
      }
    }
  },

  methods: {
    async initResources () {
      this.jubileeOrdersConfig = await JubileeService.getConfig()
    },
    async initCustomFilters () {
      this.customFilters = await JubileeService.getFilters()
    },
    jubileeOrdersLoader () {
      const params = {}
      if (this.activeFiltersDate) params.date = this.activeFiltersDate
      return JubileeService.ordersList(params)
    },
    openFormDialog (model) {
      this.jubileeOrderModel = model ? { ...model } : {
        time_specific: false,
        cd_request: false,
        songs: []
      }
      this.showFormDialog = true
    },
    async onSubmit () {
      const data = {
        ...this.jubileeOrderModel,
        date: this.formatDate(this.jubileeOrderModel.date)
      }
      if (data.id) {
        console.warn('Editing: ', data)
      } else {
        try {
          await JubileeService.createOrder(data)
          this.$refs.dtJubileeOrders.reload()
          this.showFormDialog = false
        } catch (e) {
          if (e instanceof ValidationError) {
            this.validationErrors = e.errors
          } else {
            throw e
          }
        }
      }
    },
    formatDate (vuetifyDate) {
      if (!vuetifyDate) return
      const year = vuetifyDate.substr(0, 4)
      const month = vuetifyDate.substr(5, 2)
      const day = vuetifyDate.substr(8, 2)
      return `${day}.${month}.${year}`
    },
    async downloadJubileeOrder (order) {
      await DownloadService.jubileeOrder('download', order.id)
      order.processed_at = 'on server'
    },
    async printJubileeOrder (order) {
      await DownloadService.jubileeOrder('print', order.id)
      order.processed_at = 'on server'
    },

    columnPaid (value) {
      return value ? this.$options.filters.dateTime(value) : 'Nie'
    }
  },

  created () {
    this.initResources()
    this.initCustomFilters()
  }
})
</script>
